import React from 'react';
import Chartbeat from './classes/Chartbeat';
import Meter from './classes/Meter';
import Omniture from './classes/Omniture';

/**
 * Set up the "business" functionality: the meter/paywall and analytics.
 *
 * @param {string} pageId
 * @param {boolean} meterContent
 * @param {string} section
 * @param {string} author
 * @param {string} pageName
 * @param {'production'|'development'} environment
 * @param {string} [projectName]
 */
const useBusiness = ({
  pageId,
  meterContent,
  section,
  author,
  pageName,
  environment,
  projectName,
}) => {
  React.useEffect(
    () => {
      if (!environment || !pageId) {
        return;
      }
      const omniture = new Omniture();

      (async () => {
        if (!window.bgGatsbyBusinessInitialized) {
          const meter = new Meter({
            environment,
          });
          const chartbeat = new Chartbeat({ section });
          await Promise.all([
            omniture.load(),
            chartbeat.load(),
            meter.load(),
          ]);

          chartbeat.initializeMeterObserver();
          meter.initializeMeter();

          window.bgGatsbyBusinessInitialized = true;
        }

        omniture.setupTracking({
          section,
          author,
          pageName,
          projectName,
        });

        const path = `/Page/Boston/2011-2020/WebGraphics/Metro/BostonGlobe.com/apps/index.html?${window.location.pathname}`;

        window.meterObject.executeMeter({
          loid: pageId,
          uuid: pageId,
          exemptFromMeter: !meterContent,
          pathURL: path,
        });
      })();
    },
    [environment, meterContent, pageId, section, author, pageName],
  );
};

export default useBusiness;
